const dayThisYear = new Intl.DateTimeFormat('en-US', {
  weekday: 'short',
  month: 'short',
  day: 'numeric',
});
const dayOtherYear = new Intl.DateTimeFormat('en-US', {
  month: 'short',
  day: 'numeric',
  year: 'numeric',
});

/** "Today", "Yesterday", "Mon, Oct 5" or "Oct 5, 2025" for a transfer's local day. */
export function dayLabel(iso: string | null, now: Date = new Date()): string {
  if (!iso) return 'Not yet confirmed';
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return 'Not yet confirmed';
  const startOf = (d: Date) =>
    new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();
  const days = Math.round((startOf(now) - startOf(date)) / 86_400_000);
  if (days === 0) return 'Today';
  if (days === 1) return 'Yesterday';
  return date.getFullYear() === now.getFullYear()
    ? dayThisYear.format(date)
    : dayOtherYear.format(date);
}
